module.exports = __webpack_public_path__ + "static/solidImplant-e421e760cd17f0bab552323fb22b0978.jpg";